import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslationService } from './translation.service';

@Injectable()
export class UserLanguageInterceptor implements HttpInterceptor {
  constructor(private translationService: TranslationService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const newReq = req.clone({
      setHeaders: {
        'User-Language': this.translationService.getActiveLang(),
      },
    });
    return next.handle(newReq);
  }
}
